import { DefaultValue, selector } from 'recoil';
import { v4 } from 'uuid';

import { isReloading } from '../utils/oidcUtil';

import { IAlert } from './types';
import { alertsState, selectedFolderIdState, systemFolderIdState } from './atom';
import { fetchSystemFolderId } from './utils';

export const alertsSelector = selector<IAlert[]>({
  key: 'alertsSelector',
  get: ({ get }) => get(alertsState),
});

export const alertsSelectorAdd = selector<IAlert>({
  key: 'alertsSelectorAdd',
  get: () => ({} as IAlert),
  set: ({ set, get }, newAlert) => {
    if (isReloading() || newAlert instanceof DefaultValue) {
      return;
    }
    set(alertsState, [...get(alertsState), { ...newAlert, id: v4() }]);
  },
});

export const alertsSelectorRemove = selector<string>({
  key: 'alertsSelectorRemove',
  get: () => '',
  set: ({ set, get }, id) => {
    if (id instanceof DefaultValue) {
      return;
    }
    const filteredAlerts = get(alertsState).filter((item) => item.id !== id);
    set(alertsState, filteredAlerts);
  },
});

export const systemFolderIdSelector = selector<string>({
  key: 'systemFolderIdSelector',
  get: async ({ get }) => get(systemFolderIdState) || (await fetchSystemFolderId()),
});

export const selectedFolderIdSelector = selector<string | undefined>({
  key: 'selectedFolderIdSelector',
  get: ({ get }) => get(selectedFolderIdState),
  set: ({ set }, folder) => set(selectedFolderIdState, folder),
});

export const currentFolderIdSelector = selector<string>({
  key: 'currentFolderIdSelector',
  get: ({ get }) => get(selectedFolderIdSelector) || get(systemFolderIdSelector),
});
